import {
  Alert,
  AlertDescription,
  AlertTitle,
  Icon,
  Progress,
} from '@eluve/components';
import { usePeriodicRemoteFileSyncSelector } from '@eluve/user-local-files';

export const UploadingFileLoader: React.FC<{
  appointmentId: string;
}> = ({ appointmentId }) => {
  const progress = usePeriodicRemoteFileSyncSelector((s) => {
    const { currentFile, currentFileProgress } = s.context;
    return currentFile?.appointmentId === appointmentId
      ? currentFileProgress
      : undefined;
  });

  if (progress === undefined) {
    return null;
  }

  return (
    <Alert variant="default" ref={(e) => e?.scrollIntoView()}>
      <Icon name="ArrowUpFromLine" size="lg" className="mr-4" />
      <AlertTitle>Uploading Recording</AlertTitle>
      <AlertDescription>
        <Progress value={progress} className="mt-4 h-2 w-full" />
      </AlertDescription>
    </Alert>
  );
};
